import ApiDataService from '../backend/vue-axios/api/';

// Action.js
const ApiMixin = {
    retrieveDocument(docname) {
        this.loading = true;
        this.$api.getDocument(docname)
            .then((response) => {
                this.document = response.data;
            })
            .catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false;
                return this.retrieveDocumentFile(docname);
            });
    },
    retrieveDocumentFile(docname) {
        this.loading = true;
        this.$api.getDocumentFile(docname)
            .then((response) => {
                this.forceFileDownload(response, this.document.filename);
            })
            .catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false
            });
    },
    forceFileDownload(response, title) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', title)
        document.body.appendChild(link)
        link.click()
    }, 
  }

  ApiMixin.Mixin = {
    created () {
      this.ApiMixin = ApiMixin
    },
  }
  
  export default ApiMixin
  